import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import isEmpty from 'lodash/isEmpty';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import { putRequest } from 'src/utils/request';

import messages from '../../messages';

interface Params {
  issue_date?: string;
  expiration_date?: string;
  admin_comment?: string;
}

const acceptFile = async ({
  type,
  userUuid,
  fileUuid,
  params,
}: {
  type: string;
  userUuid: string;
  fileUuid: string;
  params: Params;
}) => {
  let payload;

  if (type.includes('languages')) {
    payload = {
      user_language: params,
    };
  } else if (!isEmpty(params)) {
    payload = { asset: { ...params } };
  }

  let url = `candidates/${userUuid}/${type}/${fileUuid}`;

  if (type === 'cancellation_proofs') {
    url = `${type}/${fileUuid}`;
  }

  if (type === 'without_proof') {
    url = `cancellation_notices/${fileUuid}`;
  }

  if (type.includes('languages')) {
    url = `candidates/${userUuid}/${type}`;
  }

  const res = await putRequest(API.PUT.approveVerificationFile(url), payload);
  return res.data;
};

export const useUpdateApproveVerificationFile = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: acceptFile,
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.VERIFICATION_FILES],
      });
      handleSuccess(formatMessage(messages.approvalDone));
    },
    onError: handleError,
  });
};
